// noinspection MagicNumberJS,FunctionWithMultipleLoopsJS

document.addEventListener( 'DOMContentLoaded', () => {
	class JTFCAROUSEL {

		static MOBILE_REDUCTION_NUMBER = 0.8
		static BREAKPOINT_TABLET = 768
		static BREAKPOINT_MOBILE = 576
		static KEYCODE_LEFT_ARROW = 37
		static KEYCODE_RIGHT_ARROW = 39
		static TIMER_POINT_THREE_SECONDS = 300
		static CLASS_NAME_DOT_ACTIVE = 'jtf__carouselblock--dot-active'
		static SELECTOR_CLASS_DOT_ACTIVE = '.jtf__carouselblock--dot-active'
		static SELECTOR_CLASS_PLAY_PAUSE_BUTTON = '.jtf__carouselblock--play_pause_control button'
		static SELECTOR_CLASS_PREV = '.jtf__carouselblock--prev'
		static SELECTOR_CLASS_CONTAINER = '.jtf__carouselblock--container'
		static SELECTOR_CLASS_DOT = '.jtf__carouselblock--dot'
		static SELECTOR_CLASS_NEXT = '.jtf__carouselblock--next'
		static SELECTOR_CLASS_PANEL_IMAGE = '.jtf__carouselblock--cell-image img'
		static SELECTOR_CLASS_INNER = '.jtf__carouselblock--inner'
		static SELECTOR_CLASS_TIMELINE = '.jtf__carouselblock--timeline'
		static SELECTOR_CLASS_FIXED_CONTAINER = '.jtf__carouselblock--fixedcontainer'
		static SELECTOR_CLASS_ITEM = '.jtf__carouselblock--item'
		static SELECTOR_CLASS_IMAGE_NO_CROP = '.jtf__carouselblock--cell-image-no-crop'
		static SELECTOR_CLASS_STATIC_BG = '.jtf__carouselblock--staticbg'
		static SELECTOR_CLASS_TRANS_BG = '.jtf__carouselblock--transbg'
		static SELECTOR_CLASS_PLAY_PAUSE_CONTROL = '.jtf__carouselblock--play_pause_control'
		static SELECTOR_CLASS_DOTS = '.jtf__carouselblock--dots'
		static SELECTOR_CLASS_NAV_CONTAINER = '.jtf__carouselblock--nav'
		static ATTR_DATA_CHILDREN = 'data-children'
		static ATTR_DATA_MOBILEREDUCTION = 'data-mobilereduction'
		static ATTR_DATA_AUTOSLIDE = 'data-autoslide'
		static ATTR_DATA_AUTOSLIDEDELAY = 'data-autoslidedelay'
		static ATTR_DATA_SLIDESBGIMAGES = 'data-slidesbgimages'
		static ATTR_DATA_ARROWSTYLE = 'data-arrowstyle'
		static ATTR_DATA_STATE = 'data-state'
		static ATTR_DATA_TARGET = 'data-target'
		static ATTR_DATA_ID = 'data-id'
		static ATTR_ARIA_HIDDEN = 'aria-hidden'
		static ATTR_ARIA_SELECTED = 'aria-selected'
		static ATTR_ARIA_CONTROLS = 'aria-controls'
		static ATTR_ARIA_LABEL = 'aria-label'
		static ATTR_ARIA_LIVE = 'aria-live'
		static PROP_STATE_ENABLED = 'enabled'
		static PROP_STATE_DISABLED = 'disabled'
		static PROP_STATE_TRUE = 'true'
		static PROP_STATE_FALSE = 'false'
		static PROP_ARROW_STYLE_DEFAULT = 'defaultArrow'
		static PROP_ARROW_STYLE_DEFAULT_ICON = 'fa-angle-'
		static PROP_ARROW_STYLE_CIRCLE_ICON = 'fa-circle-chevron-'

		// noinspection FunctionWithMoreThanThreeNegationsJS
		constructor( context, wpAdmin ) {
			this.context = context
			this.carouselInner = this.context.querySelector( JTFCAROUSEL.SELECTOR_CLASS_INNER )
			this.carouselContainer = this.context.querySelector( JTFCAROUSEL.SELECTOR_CLASS_CONTAINER )
			this.carouselNav = this.context.querySelector( JTFCAROUSEL.SELECTOR_CLASS_NAV_CONTAINER )

			// If any required element is missing, retry after a short delay
			// ensures all carousels on a page load properly in WP Admin
			if ( !this.context || !this.carouselContainer || !this.carouselNav ) {
				setTimeout( () => {
					new JTFCAROUSEL( this.context, wpAdmin )
				}, 300 )
				return
			}

			this.carouselInnerChildren = this.carouselInner.getAttribute( JTFCAROUSEL.ATTR_DATA_CHILDREN )
			this.timelinePanelCount = 1
			this.carouselContainerWidth = this.context.offsetWidth
			this.timeline = this.context.querySelector( JTFCAROUSEL.SELECTOR_CLASS_TIMELINE )
			this.fixedContainer = this.context.querySelector( JTFCAROUSEL.SELECTOR_CLASS_FIXED_CONTAINER )
			this.isMobile = window.innerWidth < JTFCAROUSEL.BREAKPOINT_MOBILE
			this.individualPanel = this.context.querySelectorAll( JTFCAROUSEL.SELECTOR_CLASS_ITEM )
			this.imageNoCrop = this.context.querySelectorAll( JTFCAROUSEL.SELECTOR_CLASS_IMAGE_NO_CROP )
			this.staticBackground = this.context.querySelector( JTFCAROUSEL.SELECTOR_CLASS_STATIC_BG )
			this.tempBackground = this.context.querySelector( JTFCAROUSEL.SELECTOR_CLASS_TRANS_BG )
			this.wpAdmin = wpAdmin
			this.playPauseControl = this.context.querySelector( JTFCAROUSEL.SELECTOR_CLASS_PLAY_PAUSE_CONTROL )
			if ( !this.playPauseControl ) {
				this.playPauseControl = this.context.ownerDocument.createElement( 'div' )
				this.playPauseControl.className = 'jtf__carouselblock--play_pause_control jtf__carouselblock--navigation'
			}

			this.carouselDots = this.context.querySelector( JTFCAROUSEL.SELECTOR_CLASS_DOTS )

			this.interval = null
			this.mobileReduction = !!this.context.getAttribute( JTFCAROUSEL.ATTR_DATA_MOBILEREDUCTION ) || false
			this.autoSlide = this.carouselContainer.getAttribute( JTFCAROUSEL.ATTR_DATA_AUTOSLIDE ) || 'noneset'
			this.autoSlideDelay = this.carouselContainer.getAttribute( JTFCAROUSEL.ATTR_DATA_AUTOSLIDEDELAY ) * 1000 || 5000
			this.currentPosition = 0
			this.imageMaxHeight = 0
			this.backgroundImages = this.context.getAttribute( JTFCAROUSEL.ATTR_DATA_SLIDESBGIMAGES )
			this.containerStyle = this.carouselContainer.getAttribute( 'style' ) || ''
			this.arrowStyle = this.carouselNav.getAttribute( JTFCAROUSEL.ATTR_DATA_ARROWSTYLE ) === JTFCAROUSEL.PROP_ARROW_STYLE_DEFAULT ? JTFCAROUSEL.PROP_ARROW_STYLE_DEFAULT_ICON : JTFCAROUSEL.PROP_ARROW_STYLE_CIRCLE_ICON

			this.playIcon = '<i class="fa-solid fa-play"></i>'
			this.pauseIcon = '<i class="fa-solid fa-pause"></i>'
			this.playPauseButton = `<button type="button" href="javascript:void(0);" aria-controls="carouselblock--items" aria-label="Stop automatic slide show" ${ JTFCAROUSEL.ATTR_DATA_STATE }="${ JTFCAROUSEL.PROP_STATE_ENABLED }" ><i class="fa-solid fa-pause"></i></button>`
			this.previousButton = `<button type="button" class="jtf__carouselblock--prev jtf__carouselblock--navigation" style="${ this.containerStyle }" href="javascript:void(0);" aria-controls="carouselblock--items" aria-label="previous slide" ><i class="far ${ this.arrowStyle }left" ></i></button>`
			this.nextButton = `<button type="button" class="jtf__carouselblock--next jtf__carouselblock--navigation" href="javascript:void(0);" style="${ this.containerStyle }" aria-controls="carouselblock--items" aria-label="next slide " ><i class="far ${ this.arrowStyle }right" ></i></button>`

			this.startAutomatic = 'Start automatic slide show'
			this.stopAutomatic = 'Stop automatic slide show'

			this.reboot()
			this.loadCarousel()
		}

		navigateCarousel() {
			let transformValue
			const baseWidth = this.fixedContainer
				? this.fixedContainer.offsetWidth
				: this.carouselContainerWidth
			const slideWidth = this.timeline && !this.isMobile
				? baseWidth / this.timelinePanelCount
				: baseWidth

			transformValue = -(this.currentPosition * slideWidth * this.canvasMobileWidth())

			this.carouselInner.style.transform = `translateX(${ transformValue }px)`
			this.carouselInner.style.transitionDuration = '1s'
		}

		canvasMobileWidth() {
			return this.isMobile && this.mobileReduction ? JTFCAROUSEL.MOBILE_REDUCTION_NUMBER : 1
		}

		setMaxImageHeight() {
			if ( this.imageNoCrop.length > 0 ) {
				const cssPanelImageEl = this.context.querySelectorAll( JTFCAROUSEL.SELECTOR_CLASS_PANEL_IMAGE )
				cssPanelImageEl.forEach( ( img ) => {
					img.style.visibility = 'hidden'
				} )

				cssPanelImageEl.forEach( ( img ) => {
					if ( img.complete ) {
						this.setMaxHeight( img )
					} else {
						img.addEventListener( 'load', () => {
							setTimeout( () => {
								this.setMaxHeight( img )
							}, JTFCAROUSEL.TIMER_POINT_THREE_SECONDS )
						} )
					}
				} )

				cssPanelImageEl.forEach( ( img ) => {
					if ( img.complete ) {
						this.setPanelImageCss( img )
					} else {
						img.addEventListener( 'load', () => {
							setTimeout( () => {
								this.setPanelImageCss( img, true )
							}, JTFCAROUSEL.TIMER_POINT_THREE_SECONDS )
						} )
					}
				} )
			}
		}

		setMaxHeight( img ) {
			const imgHeight = img.offsetHeight

			if ( imgHeight && parseInt( imgHeight, 10 ) > this.imageMaxHeight ) {
				this.imageMaxHeight = parseInt( imgHeight, 10 )
			}
		}

		setPanelImageCss( img, uncached = false ) {
			img.style.height = this.imageMaxHeight + 'px'
			img.style.objectFit = "contain"
			img.style.marginBottom = '1rem'
			img.style.visibility = 'visible'

			if ( uncached ) {
				img.style.opacity = '0'
				this.fadeIn( img, JTFCAROUSEL.TIMER_POINT_THREE_SECONDS )
			}
		}

		fadeIn( element, duration ) {
			element.style.opacity = '0'
			element.style.transition = `opacity ${ duration }ms`
			setTimeout( () => {
				element.style.opacity = '1'
			}, 10 )
		}

		fadeOut( element ) {
			element.style.transition = 'opacity 400ms'
			element.style.opacity = '0'
			setTimeout( () => {
				element.style.display = 'none'
			}, 400 )
		}

		changeBackgroundImage() {
			if ( JTFCAROUSEL.PROP_STATE_ENABLED === this.backgroundImages ) {
				let targetBackgroundImage = ''
				let currentBackgroundImage = ''

				const currentPosition = Number( this.currentPosition )

				this.individualPanel.forEach( ( panel ) => {
					const dataId = parseInt( panel.getAttribute( JTFCAROUSEL.ATTR_DATA_ID ), 10 )
					const imgEl = panel.querySelector( JTFCAROUSEL.SELECTOR_CLASS_PANEL_IMAGE )
					const imgSrc = imgEl ? imgEl.getAttribute( 'src' ) : ''

					if ( currentPosition === dataId ) {
						currentBackgroundImage = imgSrc
						targetBackgroundImage = imgSrc
					}
				} )

				if ( this.tempBackground ) {
					this.tempBackground.style.backgroundImage = `url(${ currentBackgroundImage })`
				}
				if ( this.staticBackground ) {
					this.staticBackground.style.backgroundImage = `url(${ targetBackgroundImage })`
				}

				if ( this.tempBackground ) {
					this.tempBackground.style.display = 'block'
				}
				if ( this.staticBackground ) {
					this.staticBackground.style.display = 'block'
				}
				if ( this.tempBackground ) {
					this.fadeOut( this.tempBackground )
				}
			}
		}

		changeAriaDisplayStates() {
			const currentPosition = Number( this.currentPosition )

			this.individualPanel.forEach( ( panel ) => {
				const isHidden = currentPosition === parseInt( panel.getAttribute( JTFCAROUSEL.ATTR_DATA_ID ), 10 ) ? JTFCAROUSEL.PROP_STATE_FALSE : JTFCAROUSEL.PROP_STATE_TRUE
				panel.setAttribute( JTFCAROUSEL.ATTR_ARIA_HIDDEN, isHidden )

				const buttons = panel.querySelectorAll( 'button, a[role="button"], a' )
				buttons.forEach( ( el ) => {
					if ( isHidden === JTFCAROUSEL.PROP_STATE_TRUE ) {
						el.setAttribute( 'tabindex', '-1' )
					} else {
						el.removeAttribute( 'tabindex' )
					}
				} )
			} )
		}

		setActiveDot() {
			const dots = this.context.querySelectorAll( JTFCAROUSEL.SELECTOR_CLASS_DOT )
			if ( !dots || dots.length === 0 ) {
				return
			}

			const currentPosition = Number( this.currentPosition )
			const activeDotEl = this.context.querySelector( JTFCAROUSEL.SELECTOR_CLASS_DOT_ACTIVE )
			if ( activeDotEl ) {
				activeDotEl.classList.remove( JTFCAROUSEL.CLASS_NAME_DOT_ACTIVE )
			}

			dots.forEach( ( dot ) => {
				const isActive = parseInt( dot.getAttribute( JTFCAROUSEL.ATTR_DATA_TARGET ), 10 ) === currentPosition
				if ( isActive ) {
					dot.classList.add( JTFCAROUSEL.CLASS_NAME_DOT_ACTIVE )
				}
				dot.setAttribute( JTFCAROUSEL.ATTR_ARIA_SELECTED, isActive ? JTFCAROUSEL.PROP_STATE_TRUE : JTFCAROUSEL.PROP_STATE_FALSE )
			} )
		}

		moveToNextSlide() {
			const calcNewPosition = Number( this.currentPosition ) + 1

			if ( calcNewPosition < parseInt( this.carouselInnerChildren, 10 ) ) {
				this.currentPosition = calcNewPosition
			} else {
				this.currentPosition = 0
			}

			this.changeBackgroundImage()
			this.changeAriaDisplayStates()
			this.setActiveDot()
			this.navigateCarousel()
		}

		moveToPrevSlide() {
			this.carouselContainer.setAttribute( 'data-max', JTFCAROUSEL.PROP_STATE_FALSE )
			const calcNewPosition = Number( this.currentPosition ) - 1

			if ( Number( this.currentPosition ) > 0 ) {
				this.currentPosition = calcNewPosition
			} else {
				this.currentPosition = parseInt( this.carouselInnerChildren, 10 ) - 1
			}

			this.changeBackgroundImage()
			this.changeAriaDisplayStates()
			this.setActiveDot()
			this.navigateCarousel()
		}

		autoSlideCarousel() {
			this.currentPosition = Number( this.currentPosition ) < parseInt( this.carouselInnerChildren, 10 ) - 1
				? Number( this.currentPosition ) + 1
				: 0

			this.changeBackgroundImage()
			this.changeAriaDisplayStates()
			this.setActiveDot()
			this.navigateCarousel()
		}

		createSwipeEventListener( element ) {
			let startX = 0
			let startY = 0
			let suppressClickUntil = 0

			const onStart = ( x, y ) => {
				startX = x
				startY = y
			}

			const onEnd = ( x, y ) => {
				const deltaX = x - startX
				const deltaY = y - startY
				const minimumDistance = 50

				if ( Math.abs( deltaX ) < Math.abs( deltaY ) ) {
					return
				}
				if ( Math.abs( deltaX ) < minimumDistance ) {
					return
				}

				suppressClickUntil = Date.now() + 500
				element.dispatchEvent(
					new CustomEvent( deltaX > 0 ? 'swiperight' : 'swipeleft' ),
				)
			}

			const onClick = ( e ) => {
				if ( Date.now() > suppressClickUntil ) {
					return
				}

				e.preventDefault()
				e.stopPropagation()
				suppressClickUntil = 0
			}

			element.addEventListener( 'touchstart', ( e ) => {
				const t = e.changedTouches[ 0 ]
				onStart( t.clientX, t.clientY )
			} )
			element.addEventListener( 'touchend', ( e ) => {
				const t = e.changedTouches[ 0 ]
				onEnd( t.clientX, t.clientY )
			} )
			element.addEventListener( 'click', onClick, true )
		}

		startAutoSlide() {
			clearInterval( this.interval )
			this.interval = setInterval( () => {
				this.autoSlideCarousel()
			}, this.autoSlideDelay )
			this.updatePauseButtonUi( true )
		}

		stopAutoSlide() {
			clearInterval( this.interval )
			this.interval = null
			this.updatePauseButtonUi( false )
		}

		updatePauseButtonUi( isPlaying ) {
			const pauseButton = this.context.querySelector( JTFCAROUSEL.SELECTOR_CLASS_PLAY_PAUSE_BUTTON )
			if ( !pauseButton ) {
				return
			}

			if ( isPlaying ) {
				pauseButton.setAttribute( JTFCAROUSEL.ATTR_DATA_STATE, JTFCAROUSEL.PROP_STATE_ENABLED )
				pauseButton.setAttribute( JTFCAROUSEL.ATTR_ARIA_LABEL, this.stopAutomatic )
				pauseButton.innerHTML = this.pauseIcon
				this.carouselInner.setAttribute( JTFCAROUSEL.ATTR_ARIA_LIVE, 'off' )
			} else {
				pauseButton.setAttribute( JTFCAROUSEL.ATTR_DATA_STATE, JTFCAROUSEL.PROP_STATE_DISABLED )
				pauseButton.setAttribute( JTFCAROUSEL.ATTR_ARIA_LABEL, this.startAutomatic )
				pauseButton.innerHTML = this.playIcon
				this.carouselInner.setAttribute( JTFCAROUSEL.ATTR_ARIA_LIVE, 'polite' )
			}
		}

		checkIsPlaying() {
			const pauseButton = this.context.querySelector( JTFCAROUSEL.SELECTOR_CLASS_PLAY_PAUSE_BUTTON )
			return pauseButton && pauseButton.getAttribute( JTFCAROUSEL.ATTR_DATA_STATE ) === JTFCAROUSEL.PROP_STATE_ENABLED
		}

		loadCarousel() {
			if ( this.context.__jtfCarouselEventsBound ) {
				// Keep UI state current on rerender without rebinding handlers
				this.setActiveDot()
				this.changeAriaDisplayStates()
				return
			}
			this.context.__jtfCarouselEventsBound = true

			this.changeBackgroundImage()
			this.changeAriaDisplayStates()
			this.setActiveDot()

			if ( JTFCAROUSEL.PROP_STATE_ENABLED === this.autoSlide ) {
				// Start autoplay in BOTH frontend and admin
				this.startAutoSlide()
				this.context.addEventListener( 'click', ( e ) => {
					const pauseButton = e.target.closest( JTFCAROUSEL.SELECTOR_CLASS_PLAY_PAUSE_BUTTON )
					if ( !pauseButton ) {
						return
					}

					e.stopPropagation()

					if ( this.checkIsPlaying() ) {
						this.stopAutoSlide()
					} else {
						this.startAutoSlide()
					}
				} )

				// Preserve existing "pause on first hover" behaviour
				const mouseEnterHandler = ( e ) => {
					e.stopPropagation()
					this.stopAutoSlide()
					this.context.removeEventListener( 'mouseenter', mouseEnterHandler )
				}
				this.context.addEventListener( 'mouseenter', mouseEnterHandler, { once: true } )
			}

			const carouselContainer = this.context.querySelector( JTFCAROUSEL.SELECTOR_CLASS_CONTAINER )

			if ( carouselContainer ) {
				this.createSwipeEventListener( carouselContainer )

				carouselContainer.addEventListener( 'swiperight', () => {
					if ( this.checkIsPlaying() ) { this.stopAutoSlide() }
					this.moveToPrevSlide()
				} )
				carouselContainer.addEventListener( 'swipeleft', () => {
					if ( this.checkIsPlaying() ) { this.stopAutoSlide() }
					this.moveToNextSlide()
				} )
			}

			this.context.addEventListener( 'click', ( e ) => {
				const prevButton = e.target.closest( JTFCAROUSEL.SELECTOR_CLASS_PREV )
				if ( prevButton ) {
					e.stopPropagation()
					if ( this.checkIsPlaying() ) { this.stopAutoSlide() }
					this.moveToPrevSlide()
				}
			} )

			this.context.addEventListener( 'keyup', ( e ) => {
				if ( e.which === JTFCAROUSEL.KEYCODE_LEFT_ARROW ) {
					if ( this.checkIsPlaying() ) { this.stopAutoSlide() }
					this.moveToPrevSlide()
				}
			} )

			this.context.addEventListener( 'click', ( e ) => {
				const nextButton = e.target.closest( JTFCAROUSEL.SELECTOR_CLASS_NEXT )
				if ( nextButton ) {
					e.stopPropagation()
					if ( this.checkIsPlaying() ) { this.stopAutoSlide() }
					this.moveToNextSlide()
				}
			} )

			this.context.addEventListener( 'keyup', ( e ) => {
				if ( e.which === JTFCAROUSEL.KEYCODE_RIGHT_ARROW ) {
					if ( this.checkIsPlaying() ) { this.stopAutoSlide() }
					this.moveToNextSlide()
				}
			} )

			this.context.addEventListener( 'click', ( e ) => {
				const dotButton = e.target.closest( JTFCAROUSEL.SELECTOR_CLASS_DOT )
				if ( dotButton ) {
					const position = parseInt( dotButton.getAttribute( JTFCAROUSEL.ATTR_DATA_TARGET ), 10 )

					if ( Number.isNaN( position ) ) {
						return
					}

					if ( Number( this.currentPosition ) === position ) {
						this.changeBackgroundImage()
						this.changeAriaDisplayStates()
						this.setActiveDot()
						return
					}

					this.currentPosition = position
					if ( this.checkIsPlaying() ) { this.stopAutoSlide() }
					this.changeBackgroundImage()
					this.changeAriaDisplayStates()
					this.setActiveDot()
					this.navigateCarousel()
				}
			} )
		}

		// noinspection FunctionWithMoreThanThreeNegationsJS
		generateNavigation( slideCount ) {
			if ( !this.carouselDots ) {
				this.removeNavigation()
				return
			}

			const totalSlides = parseInt( slideCount, 10 ) || 0

			const hasExcludeDotsClass = ( el ) => {
				if ( !el || !el.classList ) {
					return false
				}
				return (
					el.classList.contains( 'exclude-dots' ) ||
					el.classList.contains( 'jtf__carouselblock--exclude-dots' )
				)
			}

			const currentDots = this.carouselNav.querySelector( JTFCAROUSEL.SELECTOR_CLASS_DOTS )
			const shouldExcludeDots = hasExcludeDotsClass( currentDots )
			const existingDots = currentDots
				? currentDots.querySelectorAll( JTFCAROUSEL.SELECTOR_CLASS_DOT )
				: []

			const hasPrev = !!this.carouselNav.querySelector( JTFCAROUSEL.SELECTOR_CLASS_PREV )
			const hasNext = !!this.carouselNav.querySelector( JTFCAROUSEL.SELECTOR_CLASS_NEXT )
			const hasPlayPause = !!this.carouselNav.querySelector( JTFCAROUSEL.SELECTOR_CLASS_PLAY_PAUSE_BUTTON )
			const shouldHavePlayPause = this.autoSlide === JTFCAROUSEL.PROP_STATE_ENABLED

			// Fast-path
			if (
				currentDots &&
				hasPrev &&
				hasNext &&
				(shouldHavePlayPause ? hasPlayPause : true) &&
				(
					(shouldExcludeDots && existingDots.length === 0) ||
					( !shouldExcludeDots && existingDots.length === totalSlides)
				)
			) {
				this.carouselDots = currentDots
				if ( !shouldExcludeDots ) {
					this.setActiveDot()
				}
				return
			}

			// Rebuild navigation only when required
			this.carouselNav.innerHTML = this.carouselDots.outerHTML
			this.carouselDots = this.carouselNav.querySelector( JTFCAROUSEL.SELECTOR_CLASS_DOTS )
			if ( !this.carouselDots ) {
				this.removeNavigation()
				return
			}

			const rebuiltExcludeDots = hasExcludeDotsClass( this.carouselDots )

			this.carouselDots.insertAdjacentHTML( 'beforebegin', this.previousButton )

			if ( shouldHavePlayPause && this.playPauseControl ) {
				this.playPauseControl.innerHTML = ''
				this.playPauseControl.insertAdjacentHTML( 'beforeend', this.playPauseButton )
				this.carouselDots.insertAdjacentElement( 'beforebegin', this.playPauseControl )
			}

			this.carouselDots.innerHTML = ''

			if ( !rebuiltExcludeDots ) {
				for ( let x = 0; x < totalSlides; x++ ) {
					const activeClass = x === 0 ? JTFCAROUSEL.CLASS_NAME_DOT_ACTIVE : ''
					const ariaSelect = x === 0 ? JTFCAROUSEL.PROP_STATE_TRUE : JTFCAROUSEL.PROP_STATE_FALSE
					this.carouselDots.insertAdjacentHTML(
						'beforeend',
						`<button type="button" class="jtf__carouselblock--dot ${ activeClass }" ${ JTFCAROUSEL.ATTR_ARIA_SELECTED }="${ ariaSelect }" ${ JTFCAROUSEL.ATTR_DATA_TARGET }="${ x }" style="${ this.containerStyle }" role="tab" ${ JTFCAROUSEL.ATTR_ARIA_LABEL }="Slide ${ x + 1 }" ${ JTFCAROUSEL.ATTR_ARIA_CONTROLS }="carouselblock--item--${ x + 1 }"><i class="fas fa-circle"></i></button>`,
					)
				}
			}

			this.carouselDots.insertAdjacentHTML( 'afterend', this.nextButton )

			if ( !rebuiltExcludeDots ) {
				this.setActiveDot()
			}
		}

		removeNavigation() {
			const container = this.context.querySelector( JTFCAROUSEL.SELECTOR_CLASS_NAV_CONTAINER )
			if ( container ) {
				container.innerHTML = ''
			}
		}

		reboot() {
			this.currentPosition = 0

			if ( this.timeline ) {
				const maxTimelinePanels = Math.min( 4, this.individualPanel.length )

				if ( window.innerWidth < JTFCAROUSEL.BREAKPOINT_TABLET ) {
					this.timelinePanelCount = window.innerWidth < JTFCAROUSEL.BREAKPOINT_MOBILE ? 1 : 2
				} else {
					this.timelinePanelCount = window.innerWidth < JTFCAROUSEL.BREAKPOINT_MOBILE ? 1 : maxTimelinePanels
				}

				this.carouselInner.setAttribute( JTFCAROUSEL.ATTR_DATA_CHILDREN, this.timelinePanelCount )
			}

			const baseWidth = this.fixedContainer
				? this.fixedContainer.offsetWidth
				: this.carouselContainerWidth
			const widthMultiplier = this.canvasMobileWidth()

			const itemWidth = this.timeline
				? (baseWidth / this.timelinePanelCount) * widthMultiplier
				: baseWidth * widthMultiplier

			this.carouselInner.style.transform = 'translateX(0)'
			const panelCss = {
				width: itemWidth + 'px',
				display: 'inline-flex',
			}

			if ( this.wpAdmin.length > 0 ) {
				setTimeout( () => {
					if ( this.carouselInnerChildren > 1 || this.timeline ) {
						this.generateNavigation( this.carouselInnerChildren, this.context )
					} else {
						this.removeNavigation()
					}
					this.individualPanel.forEach( ( panel ) => {
						panel.style.width = panelCss.width
						panel.style.display = panelCss.display
					} )
					this.setMaxImageHeight()
				}, JTFCAROUSEL.TIMER_POINT_THREE_SECONDS )
			} else {
				if ( this.carouselInnerChildren > 1 || this.timeline ) {
					this.generateNavigation( this.carouselInnerChildren )
				} else {
					this.removeNavigation()
				}
				this.individualPanel.forEach( ( panel ) => {
					panel.style.width = panelCss.width
					panel.style.display = panelCss.display
				} )
				this.setMaxImageHeight()
			}
		}
	}

	const INIT_ATTR = 'data-jtf-carousel-initialised'
	const BLOCK_SELECTOR = '.wp-block-jtf-jtf-carousel'

	const initBlock = ( block, isAdmin ) => {
		if ( !block || block.getAttribute( INIT_ATTR ) === JTFCAROUSEL.PROP_STATE_TRUE ) {
			return
		}

		block.setAttribute( INIT_ATTR, JTFCAROUSEL.PROP_STATE_TRUE )
		const adminContext = isAdmin ? [ block.ownerDocument.documentElement ] : []
		new JTFCAROUSEL( block, adminContext )
	}

	const initInDocument = ( doc, isAdmin = false ) => {
		if ( !doc ) {
			return
		}
		doc.querySelectorAll( BLOCK_SELECTOR ).forEach( ( block ) => {
			initBlock( block, isAdmin )
		} )
	}

	const initFromNode = ( node, isAdmin ) => {
		if ( !node || node.nodeType !== 1 ) {
			return
		}

		if ( node.matches && node.matches( BLOCK_SELECTOR ) ) {
			initBlock( node, isAdmin )
		}

		if ( node.querySelectorAll ) {
			node.querySelectorAll( BLOCK_SELECTOR ).forEach( ( block ) => {
				initBlock( block, isAdmin )
			} )
		}
	}

	const observeDocument = ( doc, isAdmin ) => {
		if ( !doc || doc.__jtfCarouselObserverBound ) {
			return
		}
		doc.__jtfCarouselObserverBound = true

		let debounceId = null

		const pendingNodes = new Set()
		const flush = () => {
			pendingNodes.forEach( ( node ) => {
				initFromNode( node, isAdmin )
			} )
			pendingNodes.clear()
			debounceId = null
		}

		const observer = new MutationObserver( ( mutations ) => {
			mutations.forEach( ( mutation ) => {
				mutation.addedNodes.forEach( ( node ) => {
					pendingNodes.add( node )
				} )
			} )

			if ( debounceId ) {
				clearTimeout( debounceId )
			}
			debounceId = setTimeout( flush, 120 )
		} )

		observer.observe( doc.body || doc.documentElement, {
			childList: true,
			subtree: true,
		} )

		// Single initial scan only
		initInDocument( doc, isAdmin )
	}

	const bindFrame = ( frame ) => {
		if ( !frame || frame.__jtfCarouselFrameBound ) {
			return
		}
		frame.__jtfCarouselFrameBound = true

		const setupFrameDoc = () => {
			let frameDoc
			try {
				frameDoc = frame.contentDocument || (frame.contentWindow ? frame.contentWindow.document : null)
			} catch ( err ) {
				frameDoc = null
			}

			if ( !frameDoc ) {
				return
			}

			observeDocument( frameDoc, true )
		}

		frame.addEventListener( 'load', setupFrameDoc )
		setupFrameDoc()
	}

	// noinspection FunctionWithMoreThanThreeNegationsJS
	const bootstrap = () => {
		const isAdmin = !!(document.body && document.body.classList.contains( 'wp-admin' ))

		if ( !isAdmin ) {
			initInDocument( document, false )
			return
		}

		// Admin root document support (fallback / non-iframe contexts)
		observeDocument( document, true )

		// Existing iframes
		document.querySelectorAll( 'iframe' ).forEach( ( frame ) => {
			bindFrame( frame )
		} )

		// Late-mounted iframes (common in Gutenberg)
		if ( !document.__jtfCarouselFrameObserverBound ) {
			document.__jtfCarouselFrameObserverBound = true

			const frameObserver = new MutationObserver( ( mutations ) => {
				mutations.forEach( ( mutation ) => {
					mutation.addedNodes.forEach( ( node ) => {
						if ( !node || node.nodeType !== 1 ) {
							return
						}

						if ( node.matches && node.matches( 'iframe' ) ) {
							bindFrame( node )
						}

						if ( node.querySelectorAll ) {
							node.querySelectorAll( 'iframe' ).forEach( ( frame ) => {
								bindFrame( frame )
							} )
						}
					} )
				} )
			} )

			frameObserver.observe( document.body || document.documentElement, {
				childList: true,
				subtree: true,
			} )
		}
	}

	bootstrap()
} )